import { ApplessOccupancyLogsData } from 'components/structure/Space/SpaceAnalytics/ApplessOccupancyLogsTable';
import {
  ApplessOccupancyEventResponse,
  ApplessOccupancySensorResponse
} from 'services/hooks/space-service';

export enum ApplessOccupancyEventType {
  Ping = 'ping',
  Reset = 'reset',
  Set = 'set',
  Entry = 'entry',
  Exit = 'exit'
}

/**
 * Get the appless occupancy sensor logs for a given building and sensor within a specified date range
 * @param eventLogs logs query raw data
 * @param applessOccupancySensorsData sensors query raw data
 * @param sensorId [optional] the sensor we are interested in; when omitted, all logs are returned
 * @param startDate [optional] the start date for filtering logs
 * @param endDate [optional] the end date for filtering logs
 * @returns sensor logs
 */
export const transformApplessOccupancyLogsData = (
  eventLogs?: ApplessOccupancyEventResponse[],
  applessOccupancySensorsData?: ApplessOccupancySensorResponse[],
  sensorId?: string,
  startDate?: Date,
  endDate?: Date
): ApplessOccupancyLogsData[] => {
  if (!eventLogs || eventLogs.length == 0) {
    return [];
  }

  return eventLogs
    .filter((log) => {
      const logDate = new Date(log.sensor_timestamp);

      // Filter by sensorId if provided
      const sensorMatch = sensorId ? log.sensor_id === sensorId : true;

      // Filter by date range if provided
      const dateMatch = (!startDate || logDate >= startDate) && (!endDate || logDate <= endDate);

      return sensorMatch && dateMatch;
    })
    .map((log) => {
      // Find the sensor matching the log's sensor_id
      const matchingSensor = applessOccupancySensorsData?.find(
        (sensor) => sensor.sensorId === log.sensor_id
      );

      return {
        time: new Date(log.sensor_timestamp),
        event: log.event,
        eventValue: log.event_value,
        location: matchingSensor?.location ?? ''
      };
    });
};
